import { palette } from './palette'

export const color = {
    // ——— Font / Dark ———
    fontDarkUltraHigh: palette.black.main,
    fontDarkHigh: palette.black[500],
    fontDarkMedium: palette.black[400],
    fontDarkLow: palette.black[300],
    fontDarkUltraLow: palette.black[200],

    // ——— Font / White ———
    fontWhiteUltraHigh: palette.white.main,
    fontWhiteHigh: palette.white[600],
    fontWhiteMedium: palette.white[500],
    fontWhiteLow: palette.white[400],
    fontWhiteUltraLow: palette.white[300],

    // ——— Icon / Dark ———
    iconDarkUltraHigh: palette.black.main,
    iconDarkHigh: palette.black[500],
    iconDarkMedium: palette.black[400],
    iconDarkLow: palette.black[300],
    iconDarkUltraLow: palette.black[200],

    // ——— Icon / White ———
    iconWhiteUltraHigh: palette.white.main,
    iconWhiteHigh: palette.white[600],
    iconWhiteMedium: palette.white[500],
    iconWhiteLow: palette.white[400],
    iconWhiteUltraLow: palette.white[300],

    // ——— Border / Dark ———
    borderDarkPrimary: palette.black[100],
    borderDarkSecondary: palette.black[200],
    borderDarkTertiary: palette.black[300],

    // ——— Border / White ———
    borderWhitePrimary: palette.white[200],
    borderWhiteSecondary: palette.white[300],
    borderWhiteTertiary: palette.white[400],

    // ——— BG / White ———
    bgWhitePrimary: palette.neutral[0],
    bgWhiteSecondary: palette.neutral[50],
    bgWhiteTertiary: palette.neutral[100],
    bgWhiteQuaternary: palette.neutral[200],
    bgWhiteQuinary: palette.neutral[300],

    // ——— BG / Dark ———
    bgDarkPrimary: palette.neutral[1000],
    bgDarkSecondary: palette.neutral[900],
    bgDarkTertiary: palette.neutral[850],
    bgDarkQuaternary: palette.neutral[800],
    bgDarkQuinary: palette.neutral[700],

    // ——— BG / AlphaDark ———
    bgAlphaDark50: palette.black[50],
    bgAlphaDark100: palette.black[100],
    bgAlphaDark200: palette.black[200],
    bgAlphaDark300: palette.black[300],
    bgAlphaDark400: palette.black[400],
    bgAlphaDark500: palette.black[500],
    bgAlphaDark600: palette.black[600],

    // ——— BG / AlphaWhite ———
    bgAlphaWhite50: palette.white[50],
    bgAlphaWhite100: palette.white[100],
    bgAlphaWhite200: palette.white[200],
    bgAlphaWhite300: palette.white[300],
    bgAlphaWhite400: palette.white[400],
    bgAlphaWhite500: palette.white[500],
    bgAlphaWhite600: palette.white[600],

    // ——— Colors / Blue ———
    blue100: palette.brandBlue[100],
    blue200: palette.brandBlue[200],
    blue300: palette.brandBlue[300],
    blue400: palette.brandBlue[400],
    blue500: palette.brandBlue[500],
    blue600: palette.brandBlue[600],
    blue: palette.brandBlue.main,
    blueHover: palette.brandBlue[800],
    bluePress: palette.brandBlue[900],

    // ——— Colors / Warning ———
    warning100: palette.warning[100],
    warning200: palette.warning[200],
    warning300: palette.warning[300],
    warning400: palette.warning[400],
    warning500: palette.warning[500],
    warning600: palette.warning[600],
    warningText: palette.warning[900],
    warning: palette.warning.main,
    warningHover: palette.warning[800],
    warningPress: palette.warning[900],

    // ——— Colors / Success ———
    success100: palette.success[100],
    success200: palette.success[200],
    success300: palette.success[300],
    success400: palette.success[400],
    success500: palette.success[500],
    success600: palette.success[600],
    successText: palette.success[800],
    success: palette.success.main,
    successHover: palette.success[800],
    successPress: palette.success[900],

    // ——— Colors / Critical ———
    critical100: palette.error[100],
    critical200: palette.error[200],
    critical300: palette.error[300],
    critical400: palette.error[400],
    critical500: palette.error[500],
    critical600: palette.error[600],
    criticalText: palette.error[800],
    critical: palette.error.main,
    criticalHover: palette.error[800],
    criticalPress: palette.error[900],

    // ——— Colors / Info ———
    info100: palette.info[100],
    info200: palette.info[200],
    info300: palette.info[300],
    info400: palette.info[400],
    info500: palette.info[500],
    info600: palette.info[600],
    infoText: palette.info[800],
    info: palette.info.main,
    infoHover: palette.info[800],
    infoPress: palette.info[900],
} as const

export type Color = typeof color
